import { assert } from '@ember/debug'

/**
 * Lets output better errors with proper stack traces
 * @param {*} valueToTest
 * @param {String} info - should be some sort of helpful information like: Callee::[functionName](param)
 */
export function mustBeDefined(valueToTest: any, info: string) {
  const isUndefined = valueToTest === undefined
  if (isUndefined) {
    console.group(`MustBeDefined Error: ${info} needs to be defined`)
    console.error(new Error().stack)
    console.log('Ember error below')
    assert(`You must pass ${info}`, !isUndefined) // just throw the ember error to actually throw an excep.
    console.groupEnd()
  }
}
